/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%",
      "show-mask": _vm.showMask
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticClass: "qr-box",
    attrs: {
      "id": _vm.scanId
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };